import { sendGetRequest } from '@/services/api.service'
import { API_BOT } from '@/config/api.config'

export const getSettings = clientToken => {
  return sendGetRequest(
    `${API_BOT.DEFAULT_API_URL}${API_BOT.SETTINGS_API_URL}?token=${API_BOT.DEFAULT_TOKEN}&client_token=${clientToken}`
  )
}

export const getUseCase = (clientToken, useCase) => {
  return sendGetRequest(
    `${API_BOT.DEFAULT_API_URL}${API_BOT.USE_CASE_API_URL}?token=${API_BOT.DEFAULT_TOKEN}&client_token=${clientToken}&usecase=${useCase}`
  )
}

export const getBotResponses = (clientToken, useCase, urlParams) => {
  return sendGetRequest(
    `${API_BOT.DEFAULT_API_URL}${API_BOT.BOT_API_URL}?token=${API_BOT.DEFAULT_TOKEN}&client_token=${clientToken}&usecase=${useCase}${urlParams}`
  )
}
